// extracted by mini-css-extract-plugin
export var headerXL = "SectionHero-module--headerXL--LKdSB";
export var headerL = "SectionHero-module--headerL--34aqe";
export var headerM = "SectionHero-module--headerM--2dzed";
export var headerS = "SectionHero-module--headerS--3Ltr0";
export var headerXS = "SectionHero-module--headerXS--2fUFN";
export var blogHeaderXL = "SectionHero-module--blogHeaderXL--1W9_l";
export var blogHeaderL = "SectionHero-module--blogHeaderL--2N8Q0";
export var blogHeaderM = "SectionHero-module--blogHeaderM--3uN7T";
export var blogHeaderS = "SectionHero-module--blogHeaderS--2-Kpt";
export var blogHeaderXS = "SectionHero-module--blogHeaderXS--udCvc";
export var headerPreamble = "SectionHero-module--headerPreamble--1MCrj";
export var preHeader = "SectionHero-module--preHeader--LiMq2";
export var textNormal = "SectionHero-module--textNormal--opyMx";
export var textSmall = "SectionHero-module--textSmall--LNFGP";
export var textSmallAlternate = "SectionHero-module--textSmallAlternate--2MjSm";
export var legend = "SectionHero-module--legend--2t71u";
export var caption = "SectionHero-module--caption--3NkiM";
export var gradientBackground = "SectionHero-module--gradientBackground--11AtC";
export var ellipsis = "SectionHero-module--ellipsis--1IU6h";
export var globalContainer = "SectionHero-module--globalContainer--p0oh5";
export var maxWidth = "SectionHero-module--maxWidth--rj652";
export var clipBottom = "SectionHero-module--clipBottom--3vVEC";
export var clipTopBottom = "SectionHero-module--clipTopBottom--1OMhk";
export var sectionHero = "SectionHero-module--sectionHero--3yaOp";
export var content = "SectionHero-module--content--11mue";
export var ch2 = "SectionHero-module--ch2---qJfz";
export var ch2Container = "SectionHero-module--ch2-container--2A3tc";